/**
 * @file 配信グループユーティリティ
 *
 * 配信グループのターゲット設定に関する共通処理を提供するユーティリティクラス
 * タグフォーマット、来店履歴設定、初期化処理などを担当
 */

/**
 * 配信グループ関連のユーティリティクラス
 *
 * ターゲット設定画面で使用される共通処理を提供
 */
class DistributionGroupUtils {
  /**
   * タグを配信グループ用のフォーマットに変換
   *
   * @param {any[]} tags - 変換対象のタグ配列
   * @param {string} tagType - タグの種類（latest_booking_services等）
   * @param {null} _tagClassCss - 未使用パラメータ
   * @returns {Array} フォーマット済みタグ配列
   */
  assignTagFormat(tags: any, tagType: any, _tagClassCss: null) {
    return tags.map((tag: any) => {
      // tagがオブジェクトならnameプロパティを使う。stringならそのまま
      const label = typeof tag === "object" && tag !== null ? tag.name : tag;
      return {
        value: `${tagType}${label}`,
        label: label,
        type: "additional",
      };
    });
  }
}

// シングルトンインスタンスとしてエクスポート
export default new DistributionGroupUtils();
